<template>
    <div>
        <modal name="referensiImportir" :draggable="false" :scrollable="true" :height="'auto'">
            <div class="modal fade show " tabindex="-1" style="display: block;margin-top: 2%;" aria-modal="true"
                role="dialog">
                <div class="modal-dialog  modal-xl">
                    <div class="modal-content">

                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel"> {{ $t("referensi_importir") }} </h5>
                            <button type="button" class="btn btn-default" @click.prevent="removeModals()"
                                aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>

                        <div class="modal-body">

                            <vue-good-table title="exim-ceisa-importir-list" ref="exim-ceisa-importir-list" mode="remote"
                                @on-page-change="onPageChangeImportir" @on-sort-change="onSortChangeImportir"
                                @on-column-filter="onColumnFilterImportir" @on-per-page-change="onPerPageChangeImportir"
                                :totalRows="totalRecordsImportir" :line-numbers="true" :isLoading.sync="isLoadingImportir"
                                :pagination-options="{

                                    enabled: true,
                                    perPageDropdown: [10, 50, 100, 1000, 10000],
                                    dropdownAllowAll: false,
                                }" :rows="rowsImportir" :columns="columnsImportir">



                                <template slot="table-row" slot-scope="props">
                                    <span v-if="props.column.field == 'actions'">
                                        <a href="#" title="Add" @click.prevent="addDataImportir(props.index, props.row)">
                                            <i class="mdi mdi-bookmark-plus" style="font-size:16px"></i>
                                        </a>
                                    </span>
                                    <span v-else>
                                        {{ props.formattedRow[props.column.field] }}
                                    </span>
                                </template>
                            </vue-good-table>


                        </div>


                        <div class="modal-footer justify-content-between">
                            <button type="button" class="btn btn-secondary" @click.prevent="removeModals()">{{
                                this.$t("close_txt") }}</button>
                        </div>


                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
export default {
    name: "CeisaEntitas",
    data() {
        return {
            totalRecordsImportir: 0,
            rowsImportir: [],
            columnsImportir: [

                {
                    label: this.$t('name'),
                    field: "name",
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },

                {
                    label: this.$t('countryTxt'),
                    field: "country",
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },


                {
                    label: this.$t('identity_number'),
                    field: "identity_number",
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },



                {
                    label: this.$t('nib'),
                    field: "nib",
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: "", // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [],
                        trigger: "enter", //only trigger on enter not on keyup
                    },

                },

                {
                    label: this.$t("action_txt"),
                    field: "actions",
                    thClass: 'text-center',
                    sortable: false,
                    filterOptions: {
                        customFilter: false,
                    }
                },

            ],

            serverParamsImportir: {
                columnFilters: {},
                sort: {
                    field: "",
                    type: "",
                },
                page: 1,
                per_page: 10,
            },
            
            isLoadingImportir: false,
        }
    },
    methods: {
        updateParamsImportir(newProps) {
            this.serverParamsImportir = Object.assign({}, this.serverParamsImportir, newProps);
            this.loadItemsImportir();
        },

        onColumnFilterImportir(params) {
            this.updateParamsImportir(params);
        },

        onPageChangeImportir(params) {
            this.updateParamsImportir({ page: params.currentPage });
        },

        onSortChangeImportir(params) {
            this.updateParamsImportir({
                sort: {
                    type: params[0].type,
                    field: params[0].field,
                },
            });
        },

        onPerPageChangeImportir(params) {
            this.updateParamsImportir({ per_page: params.currentPerPage });
        },

        // load items Importir
        loadItemsImportir() {
            const baseURI = this.$settings.endPointCeisa + "v1/customer/index";
            this.isLoadingImportir = true;

            return this.$http
                .get(
                    baseURI +
                    `?limit=${this.serverParamsImportir.per_page}&page=${this.serverParamsImportir.page}&sort_field=${this.serverParamsImportir.sort.field}&sort_type=${this.serverParamsImportir.sort.type}&name=${this.serverParamsImportir.columnFilters.name}&country=${this.serverParamsImportir.columnFilters.country}&identity_number=${this.serverParamsImportir.columnFilters.identity_number}&nib=${this.serverParamsImportir.columnFilters.nib}&type=IMPORTIR`,
                    { timeout: 120000 })
                .then((response) => {

                    this.isLoadingImportir = false;
                    this.rowsImportir = response.data.datas.data;
                    this.totalRecordsImportir = response.data.datas.total;

                }).catch((error) => {
                    this.loading();

                    if (error.code == "ECONNABORTED") {
                        this.error(this.$t("check_internet_connection_txt"));

                    } else {

                        if (error.response) {
                            if (error.response.status === 422) {
                                this.errors = error.response.data.errors;
                                this.resultError(error.response.data.errors);
                            } else if (error.response.status === 401) {
                                this.logout();
                            } else if (error.response.status === 403) {
                                this.$router.push("/authorized-error");
                            } else if (error.response.status === 500) {
                                this.$router.push('/server-error');
                            } else {
                                this.$router.push('/page-not-found');
                            }
                        }

                    }
                });
        },

        addDataImportir(index, row) {
            this.$emit("setValue", row);
            this.$modal.hide('referensiImportir');
        },
        removeModals() {
            this.$modal.hide('referensiImportir');
            
        }
    },
    watch: {},
    created: function() {
        this.loadItemsImportir();
    }
}
</script>

<style></style>